export const HOUSE_AUCTION_CREATE_PAGE_PATH = '/auction/house/create'
